var map = {
	"./auth-promo-canvas.svg": "8772",
	"./button-ok.svg": "df48",
	"./calendar-light.svg": "7875",
	"./check-green.svg": "81ed",
	"./comment-canvas-card.svg": "b32b",
	"./delete-trash-icon.svg": "1dbc",
	"./delete.svg": "0d45",
	"./drag.svg": "88c6",
	"./edit-blue.svg": "6bcb",
	"./edit-light-blue.svg": "61d0",
	"./edit.svg": "daf0",
	"./enter.svg": "7aa7",
	"./goals-bomb.svg": "05a6",
	"./goals-empty-icon.svg": "b2bb",
	"./idea-icon.svg": "ceb5",
	"./key-result-check.svg": "bf3d",
	"./left-arrow.svg": "6d4b",
	"./link.svg": "40a1",
	"./lock-icon-small.svg": "2527",
	"./lock-icon.svg": "47d9",
	"./logo-signup-promo.svg": "b9db",
	"./logout-icon.svg": "edff",
	"./menu-more.svg": "5dce",
	"./no-dashboard-gray.svg": "0ff6",
	"./notify.svg": "c760",
	"./ok-complete-green.svg": "573a",
	"./ok-dashboard-green.svg": "2033",
	"./onboadring-icon-wallet.svg": "a8d2",
	"./onboarding-icon-books.svg": "ec40",
	"./onboarding-icon-compass.svg": "99e1",
	"./onboarding-icon-fork.svg": "0b7a",
	"./onboarding-icon-glasses.svg": "da91",
	"./onboarding-icon-lighting.svg": "58f6",
	"./onboarding-icon-measurement.svg": "a55e",
	"./onboarding-icon-questions.svg": "40d6",
	"./onboarding-icon-twitter.svg": "5c5b",
	"./onboarding-icon-warning.svg": "eed1",
	"./plus-blue.svg": "cc0d",
	"./plus-canvas-card.svg": "2cd1",
	"./promo-signup-check.svg": "c00e",
	"./pxp-logo.svg": "a538",
	"./right-arrow.svg": "c686",
	"./roadmap-info.svg": "155b",
	"./smile.svg": "0c16",
	"./sprint-dropdown.svg": "7d84",
	"./sprint-empty-doing.svg": "3c21",
	"./sprint-empty-done.svg": "889a",
	"./sprint-empty-rq.svg": "e30e",
	"./sprint-empty-todo.svg": "4938",
	"./sprint-first-icon.svg": "327e",
	"./time.svg": "79aa",
	"./timer-green.svg": "d70f",
	"./timer.svg": "291e",
	"./todo-preview.svg": "e25b",
	"./trash-blue-icon.svg": "3d68",
	"./video-canvas-card.svg": "4f8d",
	"./video.svg": "512b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";